module.exports = __webpack_public_path__ + "static/profile-c5b36a5860cf961cc8a90202aa5de2b8.png";